import React, { useCallback } from 'react';

interface UniversalFilterCheckboxInputProps {
  value?: boolean;
  onChange: (value?: boolean) => void;
}

function UniversalFilterCheckboxInput({
  value,
  onChange
}: UniversalFilterCheckboxInputProps) {
  const handleChange = useCallback<() => void>(() => {
    onChange(!value);
  }, [value, onChange]);

  return (
    <div className="flex items-center">
      <input
        checked={!!value}
        type="checkbox"
        className="basic-checkbox"
        onChange={handleChange}
      />
    </div>
  );
}

export default UniversalFilterCheckboxInput;
